import { useEffect, useMemo, useState } from 'react';
import {
  MRT_EditActionButtons,
  MaterialReactTable,
  // createRow,
  type MRT_ColumnDef,
  type MRT_Row,
  type MRT_TableOptions,
  useMaterialReactTable,
} from 'material-react-table';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
//import { boxInfo } from './orderData';
import { IBoxsize, IOrderBoxes } from '../../interface/IOrders_Tasks';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CameraDialog from '../camera/CameraDialog';
import { v4 as uuid } from 'uuid';
import { AxiosInstance } from '../../api/apiInstance';
import { useSelector } from 'react-redux';
import { IUser } from '../../interface/IUser';
import { useParams } from 'react-router-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import { muiTableHeadCellPropsHelper } from '../../helper/helper';

// type  Props = {  
//   setSingleOrderData: ( SingleOrderData: IOrderHeader)  => void;
//   singleOrderData: IOrderHeader  ;
// }
type Props = {
  //orderName : string | undefined, orderBoxes: any)  
  setBoxCount: (value: number) => void;
  
}
function PackedBoxesTable(props: any) {
  const { setBoxCount} = props;
  //const [allBoxes, setAllBoxes] = useState([] as OrderBoxes[])
  const { orderData } = useParams();
  const [takePicture, setTakePicture] = useState(false)
  const [url, setUrl] = useState<string | null>(null);
  const [boxInfo, setBoxInfo] = useState<IBoxsize[]>([]);
  const userinfo: IUser = useSelector((state: any) => state.user)
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});
  const hiddenColumns = {
    id: false,
    linePhotoBase64: false,
  }

  const handleClickOpenCamera = () => {
    setTakePicture(true);
  };
  useEffect(() => {
    async function GetData() {
      try {
        return await AxiosInstance({
          // url of the api endpoint (can be changed)
          url: "boxes",
          method: "GET",
        }).then((res) => {
          // handle success

          setBoxInfo(res.data)
        });
      } catch (e) {
        // handle error
        console.error(e);

      }
    }
    GetData();
    console.log(orderData);
  }, [])


  const columns = useMemo<MRT_ColumnDef<IOrderBoxes>[]>(
    () => [
      {
        accessorKey: 'id',
        header: 'id',
        enableEditing: false,
        Edit: () => null,

      },

      {
        accessorFn: (row) => row?.boxSize?.sizeDesc, //alternate way
        id: "sizeDesc", //id required if you use accessorFn instead of accessorKey
        header: "boxsize",


        // Header: <i style={{ color: "red" }}>boxsize</i>, //optional custom markup
        editVariant: 'select',
        editSelectOptions:
          //boxInfo?.map(bx=> {return {value:bx.id , text: bx.sizeDesc}}),
          boxInfo?.map(bx => bx.sizeDesc),

        muiEditTextFieldProps: {

          required: true,
          error: !!validationErrors?.sizeDesc,
          helperText: validationErrors?.sizeDesc,
          //remove any previous validation errors when Box focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              sizeDesc: undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      // {
      //   accessorKey: 'boxNo',
      //   header: 'boxNo',        
      // },
      {
        accessorKey: 'boxweight',
        header: 'box weight',

        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.boxweight,
          helperText: validationErrors?.boxweight,
          //remove any previous validation errors when Box focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              boxweight: undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },


      {
        accessorKey: 'lineRemarks',
        header: 'line Remarks',
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.lineRemarks,
          helperText: validationErrors?.lineRemarks,
          //remove any previous validation errors when Box focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              lineRemarks: undefined,
            }),
        },
      },
      // {
      //   accessorKey: 'linePhotoBase64',
      //   header: 'linePhotoBase64',        
      // },

    ],
    [validationErrors],
  );

  const SaveBox = async (orderBoxes: IOrderBoxes) => {
    console.log('SaveBox ', orderBoxes.id)
    const Req = {
      lineRemarks: orderBoxes.lineRemarks,
      boxweight: orderBoxes.boxweight,
      boxNo: 1,
      boxSize: { id: orderBoxes.boxSize?.id },
      order: { id: orderData },
      id: orderBoxes.id,
    }
    console.log('SaveBox req', orderBoxes);
    if (orderBoxes.id === undefined || orderBoxes.id === '') {
      await AxiosInstance.post('order-boxes/', Req)
        .then(function (response) {
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    else {
      await AxiosInstance.patch('order-boxes/' + orderBoxes.id, Req)
        .then(function (response) {
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    refetch();


  }


  const DeleteBox = async (orderBoxesId: string) => {
    await AxiosInstance.delete('order-boxes/' + orderBoxesId)
      .then(function (response) {
      })
      .catch(function (error) {
        console.log(error);
      });
    refetch();

  }
  //CREATE action
  const handleCreateBox: MRT_TableOptions<IOrderBoxes>['onCreatingRowSave'] = async ({
    values,
    table,
  }) => {

    values.boxSize = boxInfo.find((bo) => { if (bo.sizeDesc === values['sizeDesc']) return true; else return false; });
    console.log(values);
    const newValidationErrors = validateBox(values);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }
    setValidationErrors({});

    SaveBox(values);
    table.setCreatingRow(null); //exit creating mode
  };

  //UPDATE action
  const handleSaveBox: MRT_TableOptions<IOrderBoxes>['onEditingRowSave'] = async ({
    row,
    values,
    table,
  }) => {
    values.boxSize = boxInfo.find((bo) => { if (bo.sizeDesc === values['sizeDesc']) return true; else return false; });
    const newValidationErrors = validateBox(values);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }
    setValidationErrors({});
    console.log(values, row.id)
    values.id = row.id;
    values.boxSize = boxInfo.find((bo) => { if (bo.sizeDesc === values['sizeDesc']) return true; else return false; });
    SaveBox(values);
    table.setEditingRow(null); //exit editing mode
  };

  //DELETE action
  const openDeleteConfirmModal = (row: MRT_Row<IOrderBoxes>) => {
    if (window.confirm('Are you sure you want to delete this Box?')) {
      DeleteBox(row.original.id);
    }
  };

  const {
    data: fetchedData = [],
    isError: isLoadingError,
    isFetching: isFetching,
    isLoading: isLoading,
    refetch,
  } = useGetOrderBoxes();

  //READ hook (get Orders from api)
  function useGetOrderBoxes() {
    return useQuery<IOrderBoxes[]>({
      queryKey: ['OrderBoxes'],
      queryFn: async () => {
        //send api request here
        let tmpUrl = 'order-boxes/getOrderBoxes/' + orderData;
        return await AxiosInstance.get(
          tmpUrl,


        ).then((res) => {
          
          const tmpRes = res.data as IOrderBoxes[];
          setBoxCount(tmpRes.length);
          return tmpRes;
        });
      },
      refetchOnWindowFocus: 'always',
    });
  }


  const table = useMaterialReactTable({
    columns,
    data: fetchedData,
    createDisplayMode: 'modal', //default ('row', and 'custom' are also available)
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)
    enableEditing: userinfo.userRoleName === 'Packer' || userinfo.userRoleName === 'Administrator' || userinfo.userRoleName === 'QC' ? true : false,
    enableDensityToggle: false,
    initialState: { columnVisibility: hiddenColumns, density: 'compact' },
    enableHiding: false,
    enableColumnActions: false,
    enablePagination: false,

    enableSorting: false,
    enableBottomToolbar: false,
    enableColumnFilters: false,
    enableColumnOrdering: false,
    enableColumnFilterModes: false,
    enableFilterMatchHighlighting: false,
    enableGlobalFilter: false,
    enableFullScreenToggle: false,
    getRowId: (row) => row.id,
    muiTableContainerProps: {
      sx: {
        minHeight: '300px',
      },
    },
    muiTableHeadCellProps: {
      //no useTheme hook needed, just use the `sx` prop with the theme callback
      sx: (theme) => ({
        muiTableHeadCellPropsHelper
      }),
    },
    renderCreateRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">Add New Box</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
    //optionally customize modal content
    renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">Edit Box</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
    muiTableBodyCellProps: ({ column }) => ({
      //conditionally style pinned columns
      sx: {
        fontWeight: '500',
        fontSize: '15px',
      },
    }),
    onCreatingRowCancel: () => setValidationErrors({}),
    onCreatingRowSave: handleCreateBox,
    onEditingRowCancel: () => setValidationErrors({}),
    onEditingRowSave: handleSaveBox,
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        <Tooltip title="Edit">
          <IconButton onClick={() => { table.setEditingRow(row) }}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Picture">
          <IconButton aria-label="scan" size="large" onClick={() => handleClickOpenCamera()}>
            <CameraAltIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    renderTopToolbarCustomActions: ({ table }) => (
      // <></>
      <div>
        {userinfo.userRoleName === 'Packer' || userinfo.userRoleName === 'Administrator' ||
          userinfo.userRoleName === 'QC' ? 
          <Tooltip arrow title="add">
            <IconButton onClick={() => table.setCreatingRow(true)}>
              <AddIcon />
            </IconButton>
          </Tooltip>
          : <></> 
        }
        <h3 style={{color:'red'}} >Boxes: {fetchedData.length}</h3>
        
        {/* <Tooltip arrow title="Refresh Data">
          <IconButton size="large" onClick={() => refetch()}>
            <RefreshIcon />
          </IconButton>
        </Tooltip> */}

      </div>
    ),
    state: {
      isLoading: isLoading,
      //isSaving: isCreatingTask || isUpdatingTask || isDeletingTask,
      showAlertBanner: isLoadingError,
      showProgressBars: isFetching,
    },

  });

  return <>  {takePicture ? <CameraDialog
    openCam={takePicture}
    setTakePicture={setTakePicture}
    url={url}
    setUrl={setUrl}
  /> : <></>}
    
    <MaterialReactTable table={table} /></>;
};


function validateBox(orderBoxes: IOrderBoxes) {
  console.log(orderBoxes)
  return {
    boxweight: !validateRequiredNo(orderBoxes.boxweight)
      ? 'box weight is Required'
      : '',
    sizeDesc: !validateRequired(orderBoxes.boxSize?.sizeDesc || '') ? 'sizeDesc is  Required' : '',
  };
}

const queryClient = new QueryClient();

const ExampleWithProviders = (props: any) => (
  //Put this with your other react-query providers near root of your app
  <QueryClientProvider client={queryClient} >
    <PackedBoxesTable setBoxCount={props.setBoxCount}/>
  </QueryClientProvider>
);

export default ExampleWithProviders;

const validateRequired = (value: string) => !!value.length;
const validateRequiredNo = (value: number) => !!value;




